export abstract class RuntimeErrorHandler {
  abstract handle(error: Error): void;
}
